import iconCsharp from "../assets/icons/Icon-CSharp.svg?raw";
import iconCuda from "../assets/icons/Icon-CUDA.svg?raw";
import iconElixir from "../assets/icons/Icon-Elixir.svg?raw";
import iconGo from "../assets/icons/Icon-Go.svg?raw";
import iconJava from "../assets/icons/Icon-Java.svg?raw";
import iconJavascript from "../assets/icons/Icon-Javascript.svg?raw";
import iconPython from "../assets/icons/Icon-Python.svg?raw";
import iconRust from "../assets/icons/Icon-Rust.svg?raw";
import iconTypescript from "../assets/icons/Icon-Typescript.svg?raw";

const ICON_MAP: Record<string, { svg: string; title: string }> = {
  typescript: { svg: iconTypescript, title: "TypeScript" },
  python: { svg: iconPython, title: "Python" },
  rust: { svg: iconRust, title: "Rust" },
  go: { svg: iconGo, title: "Go" },
  elixir: { svg: iconElixir, title: "Elixir" },
  cuda: { svg: iconCuda, title: "CUDA" },
  java: { svg: iconJava, title: "Java" },
  csharp: { svg: iconCsharp, title: "C#" },
  javascript: { svg: iconJavascript, title: "JavaScript" },
};

interface LanguageIconProps {
  language: string;
  label: string;
  isActive: boolean;
}

export default function LanguageIcon({ language, label, isActive }: LanguageIconProps) {
  const config = ICON_MAP[language];

  const baseSpanClass =
    "ghw-inline-flex ghw-items-center ghw-justify-center ghw-px-2 ghw-h-6 ghw-rounded ghw-text-[10px] ghw-font-bold ghw-uppercase ghw-tracking-wide ghw-shrink-0 ghw-bg-muted ghw-text-muted-foreground";
  const activeSpanClass = "ghw-bg-primary/20 ghw-text-primary";

  if (!config) {
    return (
      <span className={`${baseSpanClass}${isActive ? ` ${activeSpanClass}` : ""}`}>
        {label}
      </span>
    );
  }

  return (
    <span
      className={`ghw-inline-flex ghw-items-center ghw-justify-center ghw-w-7 ghw-h-7 ghw-rounded ghw-shrink-0 ghw-overflow-hidden ghw-mr-1 ${isActive ? "ghw-ring-1 ghw-ring-primary" : ""}`}
      aria-label={config.title}
      title={config.title}
      dangerouslySetInnerHTML={{ __html: config.svg }}
    />
  );
}
